(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("jquery"), require("angular-resource"), require("moment"), require("angular-translate"), require("angular-dynamic-locale"), require("angular-sanitize"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "jquery", "angular-resource", "moment", "angular-translate", "angular-dynamic-locale", "angular-sanitize"], factory);
	else if(typeof exports === 'object')
		exports["core"] = factory(require("base"), require("jquery"), require("angular-resource"), require("moment"), require("angular-translate"), require("angular-dynamic-locale"), require("angular-sanitize"));
	else
		root["core"] = factory(root["base"], root["jquery"], root["angular-resource"], root["moment"], root["angular-translate"], root["angular-dynamic-locale"], root["angular-sanitize"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_46__, __WEBPACK_EXTERNAL_MODULE_47__, __WEBPACK_EXTERNAL_MODULE_48__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition